import { ArrowRight, ChevronDown, Location } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";
import { Navigation } from "lucide-react";
import type React from "react";

export interface UserProfileProps extends React.ComponentProps<"div"> {
  user: { first_name: string; last_name: string };
  activeLocation: { name: string };
  size?: "small" | "large";
  isDeepLink?: boolean;
}

export function UserProfile({
  ref,
  className,
  user,
  activeLocation,
  size = "large",
  isDeepLink = false,
  ...rest
}: Readonly<UserProfileProps>) {
  return (
    <div
      ref={ref}
      className={cn(
        "flex w-full items-center justify-between rounded-sm bg-[color-mix(in_srgb,var(--color-white)_15%,var(--color-black))] py-1 text-start text-white transition-colors duration-200 hover:bg-[color-mix(in_srgb,var(--color-white)_20%,var(--color-black))]",
        size === "small" && "pr-2 pl-3",
        size === "large" && "px-2",
        className,
      )}
      {...rest}
    >
      <div className="flex min-w-0 flex-col">
        <p
          className={cn("truncate font-semibold", size === "small" && "text-normal", size === "large" && "text-large")}
        >
          {user.first_name} {user.last_name}
        </p>
        <p
          className={cn(
            "flex items-center gap-1 truncate",
            size === "small" && "text-small",
            size === "large" && "text-normal",
          )}
        >
          {isDeepLink ? (
            <Navigation className="size-3 shrink-0" aria-label="Viewing a different location than your saved one" />
          ) : (
            <Location className="size-3 shrink-0" />
          )}
          <span className="truncate">{activeLocation.name}</span>
        </p>
      </div>
      {size === "large" ? <ArrowRight className="size-3.5" /> : <ChevronDown className="size-3.5" />}
    </div>
  );
}
